export const adminStyles = {
  page: {
    shell: "flex h-full min-h-0 min-w-0 overflow-hidden",
    content: "flex h-full min-h-0 min-w-0 flex-1 overflow-hidden",
    pagePadding: "px-8 py-7",
  },
  heading: {
    eyebrow: "text-xs font-semibold uppercase text-green",
    pageTitle: "text-4xl font-semibold leading-tight",
    sectionTitle: "text-2xl font-semibold leading-tight",
    body: "max-w-5xl text-sm leading-6",
  },
  sidebar: {
    expanded: "relative flex h-full min-h-0 w-64 flex-shrink-0 flex-col border-r py-4",
    collapsed: "relative flex h-full min-h-0 w-16 flex-shrink-0 flex-col border-r py-4",
    sectionHeader: "shrink-0 px-4 pb-[100px]",
    navigation: "flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto overscroll-contain [&>*]:shrink-0",
    scrollbar:
      "[scrollbar-width:thin] [scrollbar-color:#B7C9C4_transparent] hover:[scrollbar-color:#899996_transparent] dark:[scrollbar-color:#4B5563_transparent] dark:hover:[scrollbar-color:#6B7280_transparent] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[#B7C9C4] hover:[&::-webkit-scrollbar-thumb]:bg-[#899996] dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 dark:hover:[&::-webkit-scrollbar-thumb]:bg-gray-500 [&::-webkit-scrollbar-button]:hidden",
    link: "flex h-11 w-full items-center gap-3 px-4 text-sm font-medium transition-colors",
    collapsedLink: "flex h-11 w-full items-center justify-center transition-colors",
    drawerToggle: "border-l-2 border-transparent pl-3.5",
    drawerToggleOpen:
      "border-gray-300 bg-greyscale-10 hover:bg-greyscale-10 dark:border-gray-600 dark:bg-gray-700/60 dark:hover:bg-gray-700/60",
    drawerLink: "flex h-9 w-full items-center px-12 text-xs transition-colors",
    drawerPopover:
      "fixed z-40 max-h-[calc(100dvh-2rem)] w-56 overflow-y-auto overscroll-contain border border-greyscale-20 bg-white py-2 shadow-lg dark:border-gray-700 dark:bg-gray-800",
    returnLink:
      "mt-auto flex min-h-12 w-full shrink-0 items-center gap-3 border-t px-4 text-xs font-semibold transition-colors",
    collapsedReturnLink: "mt-auto flex min-h-12 w-full shrink-0 items-center justify-center border-t transition-colors",
  },
  secondaryNav: {
    shell: "flex h-full w-72 flex-shrink-0 flex-col overflow-hidden border-r bg-[#E9F4F3]",
    list: "min-h-0 flex-1 overflow-y-auto px-0 py-4",
    section: "border-t border-[#C9DFDC] py-4 first:border-t-0 first:pt-0",
    group: "px-4 pb-2 text-xs font-extrabold uppercase text-green",
    item: "w-full px-4 py-2 text-left text-xs leading-5 transition-colors",
    itemActive: "bg-white font-semibold text-green shadow-[inset_3px_0_0_#1F8475]",
    itemInactive: "text-[#4A5655] hover:bg-white/60 hover:text-green",
  },
  panel: {
    params: "grid gap-4 bg-white px-5 py-4 shadow-sm dark:bg-gray-800",
    actionGrid: "grid gap-4 xl:grid-cols-2",
    safe: "min-h-[190px] bg-[#EEF8F6] p-5 shadow-[inset_4px_0_0_#1F8475]",
    live: "min-h-[190px] bg-[#FFF1F1] p-5 shadow-[inset_4px_0_0_#BF0002]",
  },
  card: {
    surface: "bg-white shadow-sm dark:bg-gray-800",
    tintedSurface: "bg-[#E9F4F3] shadow-sm dark:bg-gray-800",
    loading: "flex min-h-[320px] items-center justify-center bg-white text-sm shadow-sm dark:bg-gray-800",
    indicator: "min-w-0 px-4 py-4 shadow-sm",
    indicatorCompact: "min-w-0 px-4 py-3 shadow-sm",
  },
  button: {
    primary:
      "inline-flex min-h-[40px] w-fit max-w-full flex-none items-center justify-center gap-2 self-start px-4 py-2 text-sm font-semibold text-white transition-colors [&>svg]:shrink-0",
    safe: "bg-green hover:bg-[#166b60]",
    live: "bg-[#BF0002] hover:bg-[#A00002]",
    disabled: "disabled:cursor-not-allowed disabled:opacity-50",
  },
};
